import { FormControl, FormLabel } from '@chakra-ui/react';
import { TransactionSide } from '@client/graphql/__generated__/types';
import { Select } from '@document/common/Select';
import { FC, useMemo } from 'react';
import { useOrganizationCompliancePage } from '~/apps/consumer/pages/Organizations/Compliance/OrganizationCompliancePageContext';

interface SideOption {
  label: string;
  value: TransactionSide | 'ALL';
}

const sideOptions: SideOption[] = [
  { label: 'All', value: 'ALL' },
  { label: 'Buy', value: TransactionSide.BUY },
  { label: 'Sell', value: TransactionSide.SELL },
];

export const SideFilter: FC = () => {
  const { sideFilter, setSideFilter } = useOrganizationCompliancePage();

  const value = useMemo(
    () => sideOptions.find((option) => option.value === sideFilter),
    [sideFilter]
  );

  const handleChange = (option: SideOption | null) => {
    if (option) {
      setSideFilter(option.value);
    }
  };

  return (
    <FormControl>
      <FormLabel>Transaction Side</FormLabel>
      <Select
        isClearable={false}
        menuPortalTarget={document.body}
        options={sideOptions}
        placeholder="Transaction Side"
        size="sm"
        styles={{
          container: (provided) => ({
            ...provided,
            minWidth: 150,
          }),
          menuPortal: (base) => ({
            ...base,
            zIndex: 9999,
          }),
        }}
        value={value}
        onChange={handleChange}
      />
    </FormControl>
  );
};
